/* Animaciones de entrada al hacer scroll — Davie Lake View */
(function () {
  'use strict';
  var els = document.querySelectorAll('.davie-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();

/* Botón flotante — aparece cuando el hero sale de cuadro, se esconde sobre
   el formulario y sobre el footer para no competir con el botón de envío.

   Lectura por getBoundingClientRect en un listener de scroll ya limitado por
   tiempo, no por requestAnimationFrame: en una pestaña en segundo plano rAF
   no corre, y con un flag de "ya estoy midiendo" el botón se queda trabado
   para siempre al volver. */
(function () {
  'use strict';
  var sticky = document.querySelector('[data-davie-sticky]');
  if (!sticky) return;

  var hero = document.querySelector('.davie-hero');
  var heroCta = document.querySelector('.davie-hero__cta');
  var form = document.querySelector('#davie-lead-form');
  var pie  = document.querySelector('.davie-footer, footer');

  function enPantalla(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function actualizar() {
    // Releva al boton del hero en cuanto ESE sale por arriba, no cuando
    // sale el hero entero. Con el hero de 1.5 pantallas en telefono, lo
    // segundo dejaba un tramo largo sin ningun boton a la vista. Y sigue
    // sin competir con el: mientras el del hero se ve, este no aparece.
    var relevo = heroCta || hero;
    var fueraDelHero = relevo
      ? relevo.getBoundingClientRect().bottom <= 0
      : window.scrollY > window.innerHeight;
    sticky.classList.toggle('is-visible', fueraDelHero && !enPantalla(form) && !enPantalla(pie));
  }

  var ultimo = 0;
  window.addEventListener('scroll', function () {
    var ahora = Date.now();
    if (ahora - ultimo < 60) return;
    ultimo = ahora;
    actualizar();
  }, { passive: true });
  window.addEventListener('resize', actualizar, { passive: true });
  actualizar();
})();
